export default __webpack_public_path__ + "static/media/banner.3f5b09b6.webp";